export function getBirdviewTileKey(tile) {
  return tile.key
}
